import(/* webpackMode: "eager" */ "/opt/project/src/app/error.js");
